import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { ScrollArea } from '@/components/ui/scroll-area'

function highlightJson(json: string | undefined): string {
  if (!json) return ''
  return json.replace(
    /("(?:\\.|[^"\\])*")\s*:/g,
    '<span class="text-sky-400">$1</span>:'
  ).replace(
    /:\s*("(?:\\.|[^"\\])*")/g,
    (match, val) => match.replace(val, `<span class="text-emerald-400">${val}</span>`)
  ).replace(
    /:\s*(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g,
    (match, val) => match.replace(val, `<span class="text-amber-400">${val}</span>`)
  ).replace(
    /:\s*(true|false)/g,
    (match, val) => match.replace(val, `<span class="text-violet-400">${val}</span>`)
  ).replace(
    /:\s*(null)/g,
    (match, val) => match.replace(val, `<span class="text-red-400">${val}</span>`)
  )
}

interface JsonViewerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  data: unknown
}

export function JsonViewer({ open, onOpenChange, title, data }: JsonViewerProps) {
  if (!open) return null

  const raw = JSON.stringify(data, null, 2) ?? 'null'
  const highlighted = highlightJson(raw)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[63rem] max-h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>{title || 'JSON'}</DialogTitle>
        </DialogHeader>
        <ScrollArea className="flex-1 min-h-0 overflow-y-auto">
          <pre
            className="text-xs font-mono whitespace-pre-wrap break-all p-4 bg-zinc-950 text-zinc-200 rounded-md"
            dangerouslySetInnerHTML={{ __html: highlighted }}
          />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
